<template>
	<nav class="navbar navbar-expand-lg d-none d-sm-block">
		<div class="collapse navbar-collapse d-flex justify-content-end" id="navbarText">
			<span class="navbar-text">
				Bienvenido {{ $store.state.auth.user.nombre }}
			</span>
			<li class="nav-item dropdown dropleft">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src="../assets/img/settings.png" alt="avatar" width="30px">
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <router-link :to="{name: 'ayuda'}" class="nav-link"> Ayuda </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#" @click.prevent="cerrar_sesion">Cerrar sesión</a>
        </div>
      </li>
		</div>
	</nav>
</template>

<script type="text/javascript">
  export default {
    methods: {
      cerrar_sesion: function() {
        this.$store.commit('set',{auth: {}, cliente: {}, noLeidas: 0, creditos: false});
        this.$router.push({name: 'Home'});
      }
    }
  }
</script>

<style scoped>
  li {
    list-style: none;
  }
</style>